import refreshEventsCount from '../actions/refreshEventsCount';
import { onAgendaViewDateChanged } from 'mini-calendar-agenda-store/lib/actions/publicActions';
import { onDayViewDateChanged } from 'mini-calendar-dayview-store/lib/actions/publicActions';
import { orchestrator } from 'satcheljs';
import { OwaDate } from 'owa-datetime';

const refreshEventsCountOnDateChanged = ({ newDate }: { newDate: OwaDate }) => {
    refreshEventsCount(newDate);
};

/**
 * Update events count map when agenda view scroll results in updation of selected date
 */
export const updateEventsCountOnAVDateChanged = orchestrator(
    onAgendaViewDateChanged,
    refreshEventsCountOnDateChanged
);

/**
 * Update events count map when day view swipe results in updation of selected date
 */
export const updateEventsCountOnDVDateChanged = orchestrator(
    onDayViewDateChanged,
    refreshEventsCountOnDateChanged
);
